import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { WorkflowTemplate } from 'packages/workflows/ui/WorkflowAuthorTemplate';
import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';

// Types
const RouteParamsStruct = z.object({
  workflowTemplateId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { workflowTemplateId } = RouteParamsStruct.parse(params);

  const navigate = useNavigate();

  return (
    <WorkflowTemplate
      workflowTemplateId={workflowTemplateId}
      heading="Funding Request Internal Approval"
      onCancel={() => {}}
      onSave={() => {
        navigate('/settings/funding-requests');
      }}
    />
  );
};

// Exports
const permissions: PermissionsFn = (context) => {
  return context.flags
    .productsSettingsFundingRequestsInternalApprovalsPermissions;
};
export const Route = () => (
  <PermissionGuard
    permissions={permissions}
    fallback={<Navigate to="/settings/funding-requests" replace />}
  >
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings/funding-requests" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  </PermissionGuard>
);
